import React, {useMemo} from 'react';
import {getRandomDashboardHeroImage} from "../helpers/dashboardHeroImages";
import './data-onboarding.scss';

export type LoadingDataProps = {
    title?: string,
    message?: string
}

export default function LoadingData({
    title = 'Loading your data...',
    message = 'Hang tight while BirdMap Explorer gets your sightings ready.'
}: LoadingDataProps) {
    const onboardingHeroImage = useMemo(() => getRandomDashboardHeroImage(), []);

    return (
        <section className="data-onboarding data-onboarding--loading" aria-live="polite" aria-busy="true">
            <div className="data-onboarding__content">
                <div className="data-onboarding__loading-spinner" aria-hidden="true" />
                <h1 className="data-onboarding__headline">{title}</h1>
                <div className="data-onboarding__copy">
                    <p>{message}</p>
                </div>
            </div>
            <aside
                className="data-onboarding__hero"
                aria-label="Bird in a natural habitat"
                style={{'--data-onboarding-hero-image': `url("${onboardingHeroImage}")`} as React.CSSProperties}
            />
        </section>
    )
}
